var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct privacy container"},[_c('titletag',{attrs:{"title":"FunditOn Privacy Policy"}}),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"privacyContainer"}},[_c('div',{attrs:{"name":"termly-embed","data-id":"231f936f-924d-412a-89e9-e2eef1d47304","data-type":"iframe"}})])
}]

export { render, staticRenderFns }